export enum SubscriptionStatus {
  Active = 'active',
  Starter = 'starter',
  Cancelled = 'cancelled',
}
